import React from "react";
import Overlay from "../Overlay";
import SimpleTable from "../tables/SimpleTable";
import FilterCard, { FIELD_TYPE, ReactSelect } from "../FilterCard";
import { sweetalert } from '../../App';
import { buildRow, getLabel, getLabelFromName, getNameFromID, getNamesFromIDs, getPageOptions, getlabelsFromIDs, slicePages } from "../../util/FormatUtil";
import Select from "react-select";
import NetworkUtil from "../../network/NetworkUtil";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";
import PaginationTool from "../PaginationTool";
import { BiMailSend } from "react-icons/bi";
import { FaUserPlus } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import AdminAPI from "../../network/AdminAPI";
import ServicesAPI from "../../network/ServicesAPI";
import Validator from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import TestsAPI from "../../network/TestsAPI";
import SystemAPI from "../../network/SystemAPI";
import PhoneInput from "react-phone-number-input";
import {isPossiblePhoneNumber} from 'react-phone-number-input'
import {calculateAge, isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";

interface FakeSampleGeneratorState {
  showLoading;
  tableData:{
    ID,
    ReqNum,
    FirstName,
    LastName,
    Service,
    Type,
    SpecimenID,
    TestIDs,
    SpecimenSourceID
  }[]
  services
  tests
  specimenSources
  page_options: ReactSelect[];
  selected_page?;
  totalSamples?;
  direction?: TableOrder;
  numberOfSamples: number
  email: string
  phoneNumber: string
  data:{
    ID,
    ReqNum,
    FirstName,
    LastName,
    Type: any,
    Service,
    SpecimenID,
    TestIDs,
    SpecimenSourceID
  }
  saveButton:boolean
  labValidationTestTypes
  submitted:boolean
  typeValueForFirstName:string
  numberOfTestsSelected:number
}



export class FakeSampleGenerator extends React.Component<any, FakeSampleGeneratorState> {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      tableData: [],
      totalSamples: 0,
      page_options: [{ value: "1", label: "1" }],
      selected_page: { label: 1, value: 1 },
      direction: "asc",
      numberOfSamples: null,
      email: null,
      phoneNumber: null,
      data:{
        ID: null,
        ReqNum: null,
        FirstName: '',
        LastName: '',
        Type: null,
        Service: null,
        SpecimenID: '',
        TestIDs: null,
        SpecimenSourceID: null
      },
      services: [],
      tests: [],
      specimenSources: [],
      saveButton: false,
      labValidationTestTypes: [],
      submitted: false,
      typeValueForFirstName: '',
      numberOfTestsSelected: 0
    };
  }


  componentDidMount() {
    this.setState({ showLoading: true }, async () => {
        ServicesAPI.getAllServicesForFakeSampleGenerator().then((data) => {
          this.setState({
            services: data.data,
          });
        });
        AdminAPI.getLabValidationTestTypes().then((data) => {
            this.setState({
                labValidationTestTypes: data.data
            })
        })
        TestsAPI.getAllTestDetails().then((data) => {
          this.setState({ tests: data.tests });
        });
        
        SystemAPI.getAllSpecimenSources().then(data => {
          this.setState({specimenSources: data})
        })
      this.setState({
        showLoading: false,
      });
    });
  }

  handleExportToCSV() {
    this.setState({ showLoading: true }, async () => {
      await NetworkUtil.downloadCSV(
        "/api/admin/fakeSampleGeneratorCSVEsport",
        "Internal_Samples.xlsx",
        { data: this.state.tableData } );
      this.setState({ showLoading: false });
    });
  }

  useSorter(col:Column){
    let sorter = new Sorter<any>()
    this.setState({tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any,this.state.direction), direction: this.state.direction === 'asc' ? 'desc' : 'asc'});
  }

  createTableData(){
    if(!this.state.data){
        return
    }

    let tableData = []
    for (let i = 0; i < this.state.numberOfSamples; i++) {
        tableData.push({
            ID: i+1,
            ReqNum: null,
            FirstName: this.state.data.FirstName,
            LastName: this.state.data.LastName,
            Service: this.state.data.Service,
            Type: this.state.data.Type,
            SpecimenID: '',
            TestIDs: this.state.data.TestIDs,
            SpecimenSourceID: this.state.data.SpecimenSourceID
        })
        
    this.setState({tableData: tableData})
    }
  }

  async validateTable(){
    this.setState({showLoading:true}, async() => {
        if(!this.state.tableData || this.state.tableData.length < 1){
            this.setState({showLoading: false})
            return sweetalert.fire("", "All fields in table must be complete", "error")
        }
    
        //loop through this.state.tableData and make sure all fields have value
        let invalid = false;
        for (let i = 0; i < this.state.tableData.length; i++) {
            const td = this.state.tableData[i];
            if(!td.FirstName || td.FirstName.trim().length < 1 || td.FirstName.trim().length > 50 || !td.LastName || td.LastName.trim().length < 1 || td.LastName.trim().length > 50 || !td.Type || !td.Service || !td.TestIDs || !td.SpecimenSourceID || !td.SpecimenID || td.SpecimenID.trim().length < 1 || td.SpecimenID.trim().length > 50){
                invalid = true
                break
            }
        }
    
        if(invalid){
            this.setState({showLoading: false})
            return sweetalert.fire("", "All fields in table must be complete and input fields must be less than 50 characters.", "error")
        }
    
        //check for duplicate SpecimenIDs
        if(this.state.tableData.length > 1){
          let specimenIDs = [];
          this.state.tableData.map(td => {
            specimenIDs.push(td.SpecimenID)
          })
          let duplicates = specimenIDs.filter((item, index) => specimenIDs.indexOf(item) !== index)
          if(duplicates.length > 0){
            this.setState({showLoading: false})
            return sweetalert.fire({icon: 'error', title: '', text: "Duplicate Specimen IDs detected"});
          }
        }

        let tableDataCopy = JSON.parse(JSON.stringify(this.state.tableData)) 
        tableDataCopy.map(td => {
          td.Email = this.state.email
          td.PhoneNumber = this.state.phoneNumber
          td.FirstName = td.FirstName.trim()
          td.LastName = td.LastName.trim()
          td.SpecimenID = td.SpecimenID.trim()
          td.TestIDs = JSON.stringify(td.TestIDs)
        })

        let response = await AdminAPI.createFakeSamples(tableDataCopy)
        if(!response.success){
            let msg = "Unable to create Internal Samples at this time.";
            if(response.reason){
                msg = response.reason
            }
            this.setState({showLoading: false})
            return sweetalert.fire({icon: 'error', title: "", text: msg});
        }

        sweetalert.fire({icon: 'success', title: '', text: 'Samples generated'})
        .then(()=>{
            this.setState({
                showLoading: false,
                tableData: response.samples,
                saveButton: true
            })
        });
    })
  }

  clearTable(){
    this.setState({
        tableData: [],
        saveButton: false,
        submitted: false
    })
  }

  getIsMultiTestAllow(val){
    //get tests based on service
    let service = val.Service ? this.state.services.find( (s) => s.ID === val.Service ) : null;

    //check if service allows multiple tests
    if (service && service.AllowMultipleTests) {
      return true;
    }
    else{
      return false
    } 
  }

  getServiceSpecificTests(val){
    //update tests to only be ones associated with Service
    let tests = [];

    //get tests based on service
    let service = val.Service ? this.state.services.find( (s) => s.ID === val.Service ) : null;

    //get associated tests for servcie
    if (service?.Tests) {
      let parsedTests = JSON.parse(service.Tests)
      for (let i = 0; i < parsedTests.length; i++) {
        for (let j = 0; j < this.state.tests.length; j++) {
          if (parsedTests[i] === this.state.tests[j].ID) {
            tests.push({label: this.state.tests[j].Name, value: this.state.tests[j].ID});
          }
        }
      }
    }

    return tests
  }

  getTestSpecificSpecimenSources(val){
    let specimenSources = []
    let tests = []
    if(val && val.TestIDs && val.TestIDs.length > 0){
      val.TestIDs.map(test => {
        tests.push(this.state.tests.find(t => t.ID === test))
      })

      if (tests.length > 0) {
        let shortestObj = tests.reduce((min_obj, obj) => min_obj.ValidSpecimenSources.length < obj.ValidSpecimenSources.length ? min_obj : obj );
        shortestObj.ValidSpecimenSources.map((vss) => {
          specimenSources.push({ label: vss.Name, value: vss.ID });
        });
      }
    }
    return specimenSources
  }

  isDisabled(id, field){
    let disabled = true;
    for (let i = 0; i < this.state.tableData.length; i++) {
      const element = this.state.tableData[i];
      if(field === 'TestIDs'){
        if(element.ID === id){
          if(!element[field] || element[field].length < 1){
            disabled = true;
            break;
          }
          disabled = false;
          break;
        }
      }
      else{
        if(element.ID === id){
          if(!element[field]){
            disabled = true;
            break;
          }
          disabled = false;
          break;
        }
      }
    }
    return disabled;
  }

  render() {

    let pageHeight = this.state.numberOfSamples * 65 + 350 + (this.state.numberOfTestsSelected * 5);

    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <div className="container-fluid  min-vh-100 ">
          <div className={"row"}>
            <div className="col-12 col-md-12 col-lg-8 col-xl-5 pt-2">
              <div className="card mb-2">
                <div className="card-header verlag-bold">
                  <h4>Internal Sample Generator</h4>
                </div>
                <div className="card-body">
                  {buildRow("Email",
                      <input 
                          disabled={this.state.submitted}
                          className={"form-control"}
                          autoComplete={"off"}
                          type={"search"}
                          name={"Email"}
                          onChange={(e) => {
                              this.setState({
                                  email: e.target.value
                              })
                          }}
                          value={this.state.email}
                      />,
                          "Email to send results"
                  )}
                  {buildRow("Phone #",
                    <PhoneInput
                      disabled={this.state.submitted}
                      placeholder="Enter phone #"
                      onChange={(e) => {
                        this.setState({
                            phoneNumber: e
                        })
                    }}
                      defaultCountry="US"
                      value={this.state.phoneNumber}
                    />
                    ,
                        "Phone number to text results"
                  )}
                  {buildRow("Number of Samples",
                      <input 
                          disabled={this.state.submitted}
                          max={100}
                          min={1}
                          className={"form-control"}
                          autoComplete={"off"}
                          type={"number"}
                          name={"Number of Samples"}
                          onChange={(e) => {
                              this.setState({
                                  numberOfSamples: isNaN(Number(e.target.value)) ? null : Number(e.target.value)
                              })
                          }}
                          value={this.state.numberOfSamples}
                      />,
                          "Total number of samples to generate"
                  )}
                </div>
                <div className="card-footer">
                  <button
                    className="btn immySubmitButtonOutline"
                    onClick={() => {
                        if(!this.state.data){
                            return sweetalert.fire("", "All fields must be complete", "error")
                        }
                        if(!this.state.email || isBlank(this.state.email) || isOnlyWhitespace(this.state.email)){
                          return sweetalert.fire("", "Email must be provided", "error")
                        }
                        if(!/^[^\s^&@]+@[^\s^&@]+[.][^\s^&@]+$/.test(this.state.email)){
                          return sweetalert.fire("", "Email must be valid", "error")
                        }
                        if(!this.state.phoneNumber){
                          return sweetalert.fire("", "Phone number must be provided", "error")
                        }
                        if(!isPossiblePhoneNumber(this.state.phoneNumber)){
                          return sweetalert.fire("", "Phone number must valid", "error")
                        }
                        if(!this.state.numberOfSamples || this.state.numberOfSamples < 1){
                            return sweetalert.fire("", "Number of Samples must be greater than 0", "error")
                        }
                        if(this.state.numberOfSamples && this.state.numberOfSamples > 100){
                            return sweetalert.fire("", "Number of Samples is limited to 100", "error")
                        }
                        this.setState({submitted: true})
                        this.createTableData()
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>



         
            {this.state.tableData && this.state.tableData.length > 0 && (
              <div className="col-md-12 pt-2">
                <div className="card mt-2" style={{marginBottom: '4rem'}}>
                  <div className="card-header verlag-bold stickToTop" style={{zIndex: 5}}>
                    <h4 className="text-center text-md-left">
                      Internal Samples
                      <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                        <h4 className={"float-md-right"}>
                          Total: {this.state.tableData.length}
                        </h4>
                      </section>


                    {this.state.tableData && this.state.tableData.length > 0 && this.state.tableData[0].ReqNum && 
                      <button
                        className={"d-none d-md-inline btn btn-outline-primary ml-3"}
                        onClick={() => this.handleExportToCSV()}
                      >
                        Export to CSV
                      </button>
                    }
                    </h4>
                  </div>


                  <div className="card-body p-0 m-0 table-responsive" style={{height: `${pageHeight}px`}}>
                    {this.state.tableData && this.state.tableData.length > 0 && this.state.tableData[0].ReqNum ? 
                    <SimpleTable
                        columns={[
                        { label: "Confirmation #", key: "ReqNum", popoverText: "Click to sort by Confirmation Number"},
                        { label: "Type", key: "Type", popoverText: "Click to sort by type",
                        rawFormat: (val) => {
                            return <p>{getNameFromID(val.Type, this.state.labValidationTestTypes)}</p>
                        } 
                        },
                        { label: "Service", key: "Service", popoverText: "Click to sort by Service",
                        rawFormat: (val) => {
                            return <p>{getNameFromID(val.Service, this.state.services)}</p>
                        }
                        },
                        { label: "Test(s)", key: "TestIDs", popoverText: "Click to sort by Test(s)",
                        rawFormat: (val) => {
                          let parsedTestIDs = JSON.parse(val.TestIDs)
                          let labels = parsedTestIDs.map(pt => {
                            let test = this.state.tests.find(f => f.ID === pt)
                            if(test){
                              return test.Name
                            }
                          })

                          return labels.map(m => (
                            <p className={'mb-0'}>{m}</p>
                          ))
                        }
                        },
                        { label: "Specimen Source", key: "SpecimenSourceID", popoverText: "Click to sort by Specimen Source",
                        rawFormat: (val) => {
                            return <p>{getNameFromID(val.SpecimenSourceID, this.state.specimenSources)}</p>
                        }
                        },
                        { label: "Specimen ID", key: "SpecimenID", popoverText: "Click to sort by SpecimenID", },
                        { label: "First Name", key: "FirstName", popoverText: "Click to sort by First name"},
                        { label: "Last Name", key: "LastName", popoverText: "Click to sort by Last name"},
                        ]}
                        table_data={this.state.tableData} table_style="tableFixHead"
                        columnClickedCallback={(col) => {
                        this.useSorter(col);
                        }}
                    />
                    : 
                    <SimpleTable
                      columns={[
                        { label: "Type", key: "Type",
                        rawFormat: (val) => {
                            return (
                                <Select
                                    isSearchable={true}
                                    placeholder={"Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(val.Type, this.state.labValidationTestTypes) }
                                    onChange={(e) => {
                                        const id = val.ID;
                                        const newValue = e;
                                        this.setState({typeValueForFirstName: `${newValue.label.substring(0,3)}-`})
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        Type: newValue.value, 
                                                        Service: null,
                                                        TestIDs: null, 
                                                        SpecimenSourceID: null
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                        })
                                    }}
                                    className={"state_select"}
                                    options={this.state.labValidationTestTypes}
                                />
                            )
                        } 
                        },
                        { label: "Service", key: "Service",
                        rawFormat: (val) => {
                            return (
                                <Select
                                    isDisabled={this.isDisabled(val.ID, 'Type')}
                                    isSearchable={true}
                                    placeholder={"Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabelFromName(val.Service, this.state.services) }
                                    onChange={(e) => {
                                        const id = val.ID;
                                        const newValue = e;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        Service: newValue.value,
                                                        TestIDs: null,
                                                        SpecimenSourceID: null
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                        })
                                    }}
                                    className={"state_select"}
                                    options={this.state.services.map(s => {return {label: s.Name, value: s.ID}})}
                                />
                            )
                        }
                        },
                        { label: "Test(s)", key: "TestIDs",
                        rawFormat: (val) => {
                            return (
                                <Select
                                    isDisabled={this.isDisabled(val.ID, 'Service')}
                                    isSearchable={true}
                                    isMulti={this.getIsMultiTestAllow(val)}
                                    placeholder={"Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={getlabelsFromIDs(val.TestIDs, this.state.tests)}
                                    onChange={(e) => {
                                        const id = val.ID;
                                        let isMulti = this.getIsMultiTestAllow(val);
                                        if(!isMulti){
                                          this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        TestIDs: [e.value],
                                                        SpecimenSourceID: null
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                          })
                                        }
                                        else{
                                          let totalTestIDs = JSON.parse(JSON.stringify(this.state.numberOfTestsSelected));
                                          if(e && e.length > 0){
                                            this.setState({numberOfTestsSelected: totalTestIDs + e.length})
                                          }
                                          let testIDs = [];
                                          e?.map(test => {
                                            testIDs.push(test.value)
                                          })

                                          this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        TestIDs: testIDs,
                                                        SpecimenSourceID: null
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                          })
                                        }
                                    }}
                                    className={"state_select"}
                                    options={this.state.tableData ? this.getServiceSpecificTests(val) : null}
                                />
                            )
                        }
                        },
                        { label: "Specimen Source", key: "SpecimenSourceID",
                        rawFormat: (val) => {
                            return (
                                <Select
                                    isDisabled={this.isDisabled(val.ID, 'TestIDs')}
                                    isSearchable={true}
                                    placeholder={"Select..."}
                                    noOptionsMessage={() => "No option"}
                                    value={ getLabel(val.SpecimenSourceID, this.state.specimenSources) }
                                    onChange={(e) => {
                                        const id = val.ID;
                                        const newValue = e;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        SpecimenSourceID: newValue.value
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                        })
                                    }}
                                    className={"state_select"}
                                    options={this.getTestSpecificSpecimenSources(val)}
                                />
                            )
                        }
                        },
                        { label: "Specimen ID", key: "SpecimenID", 
                        rawFormat: (val) => {
                            return (
                                <input 
                                    disabled={this.isDisabled(val.ID, 'SpecimenSourceID')}
                                    className={"form-control"}
                                    maxLength={46}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Specimen ID"}
                                    onBlur={(e) => {
                                        const id = val.ID;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        FirstName: `${this.state.typeValueForFirstName}${val.SpecimenID}`,
                                                        LastName: 'Testing',
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                        })
                                    }}
                                    onChange={(e)=>{
                                        const id = val.ID;
                                        const newValue = e.target.value;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        SpecimenID: newValue,
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                        })
                                    }}
                                    value={val.SpecimenID}
                                />
                            )    
                        }
                        },
                        { label: "First Name", key: "FirstName",
                        rawFormat: (val) => {
                            return (
                                <input 
                                    disabled={this.isDisabled(val.ID, 'SpecimenID')}
                                    className={"form-control"}
                                    maxLength={46}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"First Name"}
                                    onChange={(e)=>{
                                        const id = val.ID;
                                        const newValue = e.target.value;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        FirstName: newValue
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                    })
                                }}
                                    value={val.FirstName}
                                />
                            )    
                        }
                        },
                        { label: "Last Name", key: "LastName",
                        rawFormat: (val) => {
                            return (
                                <input 
                                    disabled={this.isDisabled(val.ID, 'SpecimenID')}
                                    className={"form-control"}
                                    maxLength={46}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Last Name"}
                                    onChange={(e)=>{
                                        const id = val.ID;
                                        const newValue = e.target.value;
                                        this.setState( (prevState) => {
                                            const updatedData = prevState.tableData.map(item => {
                                                //@ts-ignore
                                                if(item.ID === id){
                                                    return {
                                                        ...item,
                                                        LastName: newValue
                                                    };
                                                }
                                                return item;
                                            });
                                            return {tableData: updatedData};
                                    })
                                }}
                                    value={val.LastName}
                                />
                            )    
                        }
                        },
                        
                      ]}
                      table_data={this.state.tableData} table_style="tableFixHead" evenWidthHeaders={true}

                    />
                    }
                  </div>
                  <div className="card-footer">
                    <button
                        className={"btn immyClearButtonOutline"}
                        onClick={() => {
                            this.clearTable()
                        }}
                      >
                        Clear Table
                    </button>
                  {this.state.saveButton ? 
                      <span className="small float-right mt-2">*To edit sample, please proceed to Samples page</span>
                      :
                      <button
                        className={"btn immySubmitButtonOutline float-right"}
                        onClick={() => {
                            this.validateTable()
                        }}
                      >
                        Generate Samples
                      </button>
                    }
                </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
